import { TEXT_ALIGN } from "@asez/shared";
import { GenericInput } from "@asez/component-library";
import { GenericModal } from "@asez/component-library";
import { GenericSelect } from "@asez/component-library";
import { STATIC_STRINGS } from "@asez/shared";
import {
  AssessmentQuestionTypes,
  QuestionDifficultyLevelEnum,
} from "../../../../utils/enums";
import { useDispatch } from "react-redux";
import { addQuestion } from "../../../../../../store/steps/stepTwoSlice";

const AddTypeModal = ({
  newQuestion,
  setNewQuestion,
  isModalOpen,
  setModalOpen,
}) => {
  const dispatch = useDispatch();

  const handleAddType = (topicIndex: number) => {
    dispatch(addQuestion({ topicIndex, newQuestion }));
  };

  const handleConfirm = () => {
    handleAddType(newQuestion.index);
    setModalOpen("");
    setNewQuestion({
      index: 0,
      questionType: STATIC_STRINGS.MCQ,
      difficultyLevel: STATIC_STRINGS.EASY,
      numberOfQuestions: 1,
      additionalFeedback: "",
    });
  };

  const addTypeFields = [
    {
      label: STATIC_STRINGS.QUESTION_TYPE,
      component: GenericSelect,
      options: Object.values(AssessmentQuestionTypes).map((type) => ({
        label: type,
        value: type,
      })),
      value: newQuestion.questionType,
      onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
        setNewQuestion((p) => ({ ...p, questionType: e.target.value })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.DIFFICULTY_LEVEL,
      component: GenericSelect,
      options: Object.values(QuestionDifficultyLevelEnum).map((level) => ({
        label: level,
        value: level,
      })),
      value: newQuestion.difficultyLevel,
      onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
        setNewQuestion((p) => ({ ...p, difficultyLevel: e.target.value })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.NUMBER_OF_QUESTIONS,
      component: GenericInput,
      type: "number",
      textAlign: TEXT_ALIGN.center,
      value: newQuestion.numberOfQuestions?.toString() ?? 0,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNewQuestion((p) => ({
          ...p,
          numberOfQuestions: Number(e.target.value),
        })),
      className: "w-1/2",
    },
    {
      label: STATIC_STRINGS.ADDITIONAL_REQUIREMENTS,
      component: GenericInput,
      type: "text",
      value: newQuestion.additionalRequirements,
      onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setNewQuestion((p) => ({
          ...p,
          additionalRequirements: e.target.value,
        })),
      className: "w-full",
    },
  ];

  return (
    <GenericModal
      title={STATIC_STRINGS.ADD_NEW_QUESTION}
      onClose={() => {
        setModalOpen("");
      }}
      onConfirm={handleConfirm}
      open={isModalOpen}
      body={
        <div>
          {addTypeFields.map(
            ({ label, component: Component, ...props }, index) => (
              <div key={index} className="flex flex-col pb-1 items-center">
                <label className="font-medium">{label} :&nbsp;</label>
                <Component {...props} />
              </div>
            )
          )}
        </div>
      }
    />
  );
};
export default AddTypeModal;
